import { render, staticRenderFns } from "./ProfileChangePasswordForm.vue?vue&type=template&id=3867e3ba"
import script from "./ProfileChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ProfileChangePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports